import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
//import * as FullStory from '@fullstory/browser';
import * as serviceWorker from './serviceWorker';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';

import './components/FontAwesome';
import Auth from './components/auth/Auth';

var environment = process.env.REACT_APP_URL;
var sentryUrl = process.env.REACT_APP_SENTRY_URL;

//if(environment === 'https://app.landscan.ai') {
    // add monitoring here
    //FullStory.init({ orgId: '187CQW' });
//}

const auth = new Auth();

ReactDOM.render(<App auth={auth}/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
